import React from "react";
import { StarFilled } from '@ant-design/icons';
import { Tag, Tooltip } from 'antd';
import {getBarcodeUrl, getPreviewUrl} from '../../utils/utils';

const iconFontSize = "15px";

export const getPreviewComponent = (slide, is_cloud, isMobile) => {
    let previewPath = slide.preview_image;

    if (is_cloud === false) {
        previewPath = previewPath.replace("/static/", "");
        previewPath = getPreviewUrl(previewPath.replace('stitched_small_viewer', 'selection_marked'), slide);
    }
    return <img
        width={isMobile ? 100: 200}
        alt="logo"
        src={previewPath}
    />
}

export const getLabelComponent = (slide, is_cloud, isMobile) => {
    const labelPath = getBarcodeUrl(slide, is_cloud);

    return <img
        height={96}
        alt="barcode-does-not-exist"
        src={labelPath}
    />
}

export const getNameComponentCaseSlide = (slide) => {
    return <span>{slide.name}</span>
}

export const getTagsComponent = (slide) => {
    return (
        <div>
            {slide.tags.map((tag, index) => {
            tag = tag.title || "";
            const isLongTag = tag.length > 20;
            let color = 'magenta';
            const tagElem = (
                <Tag key={tag} color={color}>
                {isLongTag ? `${tag.slice(0, 20)}...` : tag}
                </Tag>
            );
            return isLongTag ? <Tooltip title={tag} key={tag}>{tagElem}</Tooltip> : tagElem;
            })}
        </div>
        );
}


export const getStarredComponent = (slide) => {
    return (
        <StarFilled
            style={{ color: slide.starred === true ? "#f5667b" : "", fontSize: iconFontSize, padding: 5, display: 'inline-table' }} />
    );
}

export const getIntegersfromString = (string) => {
    let matches = string.match(/([0-9]+)/g)
    if (matches == null) {
        return 0
    }
    return matches[0]
}

export const getLexicographicalSorting = (allSlides) => {
    return Object.keys(allSlides).sort(
        function (a, b) {
            return allSlides[a].name.localeCompare(allSlides[b].name);
        }
    )
}

export const getReverseLexicographicalSorting = (allSlides) => {
    return Object.keys(allSlides).sort(
        function (a, b) {
            return allSlides[b].name.localeCompare(allSlides[a].name);
        }
    )
}

export const getNumericalSorting = (allSlides) => {
    return Object.keys(allSlides).sort(
        function (a, b) {
            return getIntegersfromString(allSlides[a].name) - getIntegersfromString(allSlides[b].name);
        }
    )
}

export const getChronologicalSorting = (allSlides) => {
    return Object.keys(allSlides).sort(
        function (a, b) {
            return Date.parse(allSlides[a].date_time) - Date.parse(allSlides[b].date_time);
        }
    )
}

export const getReverseChronologicalSorting = (allSlides) => {
    return Object.keys(allSlides).sort(
        function (a, b) {
            return Date.parse(allSlides[b].date_time) - Date.parse(allSlides[a].date_time);
        }
    )
}

export const getAssignedNamesComponent = (caseInfo, isArchived) => {
    const max_names_to_show = 4;
    let needs_sliceing = caseInfo.assigned_users.length > max_names_to_show;
    let name_tags = caseInfo.assigned_users.map((user) => {
        const full_name = user.first_name + ' ' + user.last_name;
        const isLongUserName = full_name.length > 15;
        let color = isArchived ? null : 'magenta';
        const userNameElem = (
            <Tag key={user.id} color={color} onClick={(event) => event.stopPropagation()}>
                {isLongUserName ? `${full_name.slice(0, 15)}...` : full_name}
            </Tag>
        );
        const finalUserTag = isLongUserName ?
            <Tooltip title={full_name} key={user.id}>{userNameElem}</Tooltip> : userNameElem;
        return finalUserTag;
    });
    if (needs_sliceing) {
        const extra_names = name_tags.length - max_names_to_show;
        name_tags = name_tags.slice(0, max_names_to_show);
        name_tags.push(<Tag key={'more'} color={'magenta'} onClick={(event) => event.stopPropagation()}>
            {'+ ' + extra_names + ' more'}
        </Tag>);
    }
    return name_tags
}